export type WalletRequestStep = 1 | 2 | 3 | 4 | "confirm" | "created";

export function resolveWalletRequestStep(raw: string | undefined): WalletRequestStep {
  if (raw === "confirm" || raw === "created") return raw;
  const n = Number(raw);
  return n === 2 || n === 3 || n === 4 ? n : 1;
}
